module.exports = __webpack_public_path__ + "img/lucht.2b819b21.gif";